import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IBrandingConfig } from '../interfaces/IBrandingConfig';

class ConfigBrandingService extends EntityApiService<IBrandingConfig> {
  getBranding = (gateway: string, params?: any) => {
    return this.handleResponse(ApiClientService.get(this.getPath(`/${gateway}`), params));
  };

  updateBranding = (gateway: string, payload: IBrandingConfig, params?: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${gateway}`), payload, params));
  };
}

export default new ConfigBrandingService('/ms-pay/api/payment-settings/checkout-branding');
